module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs__And__Page_Break"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Spacing_After__And__Tabs",
    attrs: {
      "id": "auto_bookmark_toc_3"
    }
  }, [_c('span', [_vm._v("To Jackie, who inspired the entire idea in the first place.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67875b40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0003.vue
// module id = 63
// module chunks = 0